export default "__VITE_ASSET__BTv6Rhnn__"